import { render, staticRenderFns } from "./TopicContextSiteHeader.vue?vue&type=template&id=68b7adf8&scoped=true"
import script from "./TopicContextSiteHeader.vue?vue&type=script&lang=js"
export * from "./TopicContextSiteHeader.vue?vue&type=script&lang=js"
import style0 from "./TopicContextSiteHeader.vue?vue&type=style&index=0&id=68b7adf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7adf8",
  null
  
)

export default component.exports